// eslint-disable-next-line import/no-internal-modules
import isURL from 'validator/es/lib/isURL';

import { EventValidator } from './types';

export const validateCuesheetURL = (
  cueSheetURL?: string
): Pick<EventValidator.Errors, 'cueSheetURL'> => {
  const errors: EventValidator.Errors = {};

  if (!cueSheetURL || cueSheetURL.length === 0) {
    return errors;
  }

  if (!isURL(encodeURI(cueSheetURL))) {
    errors.cueSheetURL = EventValidator.ErrorMessages.INVALID_CUE_SHEET_URL;
  }

  return errors;
};

export const validateAudioCuesheetURL = (
  audioCueSheetURL?: string
): Pick<EventValidator.Errors, 'audioCueSheetURL'> => {
  const errors: EventValidator.Errors = {};

  if (!audioCueSheetURL || audioCueSheetURL.length === 0) {
    return errors;
  }

  if (!isURL(encodeURI(audioCueSheetURL))) {
    errors.audioCueSheetURL = EventValidator.ErrorMessages.INVALID_CUE_SHEET_URL;
  }

  return errors;
};
